import { FORM_CLASS_DISABLED, FORM_CLASS_FOCUS } from './common';
import classNames from 'classnames';
import IconLoading from '~/components/icons/streamline/line/IconLoading';

export interface InputSwitchProps {
  on: boolean;
  name?: string;
  disabled?: boolean;
  loading?: boolean;
  onLabel?: string;
  offLabel?: string;
  onChange?: (on: boolean) => void;
}

export default function InputSwitch(props: InputSwitchProps) {
  const check = [
    'h-5',
    'w-5',
    'rounded-full',
    'bg-white',
    'inline-block',
    'shadow',
    'transform',
    'ring-0',
    'transition',
    'ease-in-out',
    'duration-200',
    'p-0.5'
  ].join(' ');

  const background = [
    'h-6',
    'w-11',
    'border-2',
    'border-transparent',
    'rounded-full',
    'relative',
    'inline-flex',
    'shrink-0',
    'transition-colors',
    'ease-in-out',
    'duration-200',
    'focus:outline-none',
  ].join(' ');

  return (
    <div className="inline-flex flex-items space-x-2 items-center">
      <button
        type="button"
        onClick={() => !props.disabled && props.onChange && props.onChange(!props.on)}
        className={classNames(background, {
          'bg-theme-primary': props.on,
          'bg-gray-200': !props.on,
          [FORM_CLASS_DISABLED]: props.disabled,
          'cursor-pointer': !props.disabled,
          'bg-primary-100': props.on && props.disabled,
          [FORM_CLASS_FOCUS]: !props.disabled,
        })}
        disabled={props.disabled}
      >
        <span className={classNames(check, { 'translate-x-5': props.on, 'translate-x-0': !props.on })}>
          {props.loading && <IconLoading />}
        </span>
      </button>
      <div>{props.on ? props.onLabel : props.offLabel}</div>
      {props.name && <input type="hidden" value={props.on ? 'true' : ''} name={props.name} />}
    </div>
  );
}
